<h2>about the Website.</h2>
<p class="about">Die Webseite ist recht einfach aufgebaut. Die Navigation ist so gestaltet, dass ab einer gewissen Höhe
    der Hintergrund auf Weiß wechselt. Hier wollte ich die Hero-Section nicht durch einen unschönen weißen Balken
    zerstören. Auf Mobilen Geräten wird die Navigation in zwei Teile gesplittet. Die Menüführung ist am unteren Bildschirmrand und oben ist nur das Logo und der Mail-Button zusehen.
    Beim Scrollen verschwindet die obere Leiste komplett.
    <br>
    <br>
    Die Trennergrafik wurde mir als Vorlage gegeben und meine Freundin hat mir diese freundlicherweise digitalisiert.
    <br>
    <br> 
    Die Bilder sind in einem Dragable-Slider untergebracht. Hierzu habe ich eine fertige Angularkomponente verwendet. Der Standort der Schneiderei
    wurde mit Google Maps in einer Art Polaroidfoto dargestellt.
    <br>
    <br>
    Um das ganze abzurunden habe ich das Kontaktformular in einem Dialog als Postkarte gestalet.
    Da diese Webseite kein Backend verwendet habe ich für das Kontaktformular eine MailJS Integration verwendet. So können Mails auch ohne Backend versendet werden.
</p>